<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" label-width="120px" class="demo-form-inline ">
        <el-form-item label="业务系统" prop="sysId">
          <el-select v-model="form.sysId"  clearable filterable placeholder="请选择业务系统">
            <el-option :label="item.systemName" :value="item.systemId" v-for="(item, $index) in sysData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称" prop="custId">
          <el-select v-model="form.custId"  clearable filterable placeholder="请选择客户名称">
            <el-option :label="item.custName" :value="item.custId" v-for="(item, $index) in form.cusData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核算状态" prop="state">
          <el-select v-model="form.state" clearable filterable placeholder="请选择结算状态">
            <el-option label="未核算" value="0" ></el-option>
            <el-option label="已核算" value="1" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核算单生成时间" prop="date">
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="核算批次"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.checkBatch }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="系统名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="客户名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.custName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="计费总金额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.totalCharge }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="核算单生成时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="核算状态"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.checkFlag === '1' ? '已核算' : '未核算' }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="280">
          <template slot-scope="scope">
            <el-button size="mini" :disabled="scope.row.checkFlag === '1' ? true : false" @click="reAccount(scope.$index, scope.row)">重新核算</el-button>
            <el-button size="mini" :disabled="scope.row.checkFlag === '1' ? true : false" @click="nuclearAcc(scope.$index, scope.row)">核账</el-button>
            <el-button size="mini" :disabled="scope.row.settlementFlag === '1' || scope.row.checkFlag === '0' ? true: false" @click="createSheet(scope.$index, scope.row)">生成结算单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog  title="核账详情"  width="780px" center :modal-append-to-body='false' :visible.sync="accountDetailDialog">
      <el-form :model="detailInfo"  ref="detailInfo">
        <!-- <el-form-item label="下载明细账单:"   :label-width="formLabelWidth"> -->
        <!-- </el-form-item> -->
        <el-form-item label="客户名称:"  :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="detailInfo.custName" auto-complete="off"></el-input>
          <el-button type="primary"  style="float: right;"  @click="downLoad">导出明细</el-button>
        </el-form-item>
        <el-form-item label="账号名:"  :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.accountName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="当期计费金额:"   :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.sumCharge" auto-complete="off"></el-input>
        </el-form-item>
        <el-table
          :data="detailInfo.detailList"
          style="width: 100%">
          <el-table-column
            label="日期"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.checkBatch }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="服务中文名"
            :show-overflow-tooltip="tooltip"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.prodName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="单价（元）"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.unitPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="计费调用量（条）"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.chargeNum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="计费金额（元）"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.totalCharge }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="核账凭证:" :label-width="formLabelWidth">
          <img class="img" :src="item" v-for="(item, $index) in detailInfo.urlList" :key="$index" alt="">
        </el-form-item>
        <el-form-item label="备注:"    :label-width="formLabelWidth">
          <el-input type="textarea" disabled style="width: 217px;" maxlength="150"  v-model="detailInfo.remark"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog @close="closeRecharge" title="客户核算" width="780px"   center :modal-append-to-body='false' :visible.sync="rechargeDialog">
      <el-form :model="rechargeInfo"  ref="rechargeInfo">
        <!-- <el-form-item label="下载明细账单:"   :label-width="formLabelWidth"> -->
        <!-- </el-form-item> -->
        <el-form-item label="客户名称:"  :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="rechargeInfo.custName" auto-complete="off"></el-input>
          <el-button type="primary" style="float: right;"  @click="downLoad">导出明细</el-button>
        </el-form-item>
        <el-form-item label="账号名:"  :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="rechargeInfo.accountName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="当期计费金额:"   :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="rechargeInfo.sumCharge" auto-complete="off"></el-input>
        </el-form-item>
        <el-table
          :data="detailList"
          style="width: 100%">
          <el-table-column
            label="日期"
            :show-overflow-tooltip="tooltip"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.checkBatch }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="服务中文名"
            :show-overflow-tooltip="tooltip"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.prodName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="单价（元）"
            width="">
            <template slot-scope="scope">
              <el-input style="width: 100px;" :disabled="scope.row.disabled" @input="price(scope.row)" onafterpaste="this.value=this.value.toString().match(/^\d+(?:\.\d{0,4})?/)"  onkeyup="this.value=this.value.toString().match(/^\d+(?:\.\d{0,4})?/)" maxlength="30"  v-model.number="scope.row.unitPrice" auto-complete="off"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="计费调用量（条）"
            width="">
            <template slot-scope="scope">
              <el-input style="width: 100px;" @input="call(scope.row)"  :disabled="scope.row.disabled" onafterpaste="this.value=this.value.toString().match(/^\d+(?:\.\d{0,4})?/)" maxlength="30" onkeyup="this.value=this.value.toString().match(/^\d+(?:\.\d{0,4})?/)"  v-model.number="scope.row.chargeNum" auto-complete="off"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="计费金额（元）"
            width="">
            <template slot-scope="scope">
              <el-input style="width: 100px;" @input="totalCharge(scope.row)" :disabled="scope.row.disabled" onafterpaste="this.value=this.value.toString().match(/^\d+(?:\.\d{0,4})?/)" maxlength="30" onkeyup="this.value=this.value.toString().match(/^\d+(?:\.\d{0,4})?/)"  v-model.number="scope.row.totalCharge" auto-complete="off"></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" >
            <template slot-scope="scope">
              <el-button size="mini"  @click="adjust(scope.$index, scope.row)">调整</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item ref="urlRule" label="上传凭证:" style="margin-top: 22px" :label-width="formLabelWidth">
          <el-upload
            ref="upload"
            :action="action"
            list-type="picture-card"
            :headers="headers"
            :before-upload="beforeAvatarUpload"
            :on-success="success"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.GIF,.BMP"
            :file-list="fileList"
            :on-remove="handleRemove"
            :on-preview="handlePictureCardPreview">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog center :modal-append-to-body='false' :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="备注:"  :label-width="formLabelWidth">
          <el-input type="textarea"  style="width: 217px;" maxlength="150"  v-model="rechargeInfo.settlementRemark"></el-input>
        </el-form-item>
        <el-form-item style="textAlign: center;">
          <el-button @click="rechargeDialog=false">取 消</el-button>
          <el-button type="primary"  @click="rechargeSave('rechargeInfo')">核账</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog  title="更新核算单"  width="500px" center :modal-append-to-body='false' :visible.sync="accountingDialog">
      <el-form :model="accountingInfo"  ref="detailInfo">
        <el-form-item label="系统名称:"   :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="accountingInfo.sysName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="客户名称:"  :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="accountingInfo.custName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="核算开始时间:"  :label-width="formLabelWidth">
          <el-date-picker
            v-model="accountingInfo.startDate"
            type="date"
            value-format="yyyy-MM-dd"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="核算截止时间:"  :label-width="formLabelWidth">
          <el-date-picker
            v-model="accountingInfo.endDate"
            type="date"
            value-format="yyyy-MM-dd"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="计费总金额:"   :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="accountingInfo.sumCharge" auto-complete="off"></el-input>
          <el-button  type="primary"  @click="autoAccount">自动核算</el-button>
        </el-form-item>
        <el-form-item style="textAlign: center;">
          <el-button @click="accountingDialog=false">取 消</el-button>
          <el-button type="primary"  @click="accountingSave">保 存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.img {
  width: 100px;
  height: 100px;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'customerList',
  data () {
    return {
      form: {
        sysId: '',
        custId: '',
        cusData: [],
        state: '',
        date: ''
      },
      tooltip: true,
      supData: [],
      num: 1,
      headers: {
        mtk: localStorage.getItem('usermtk')
      },
      detailList: [],
      noAdjust: [], // 存放调账之前的数据
      modalClick: false,
      rechargeDialog: false,
      accountingDialog: false,
      accountDetailDialog: false,
      editable: false,
      required: true,
      action: this.$API.fileUpload,
      dialogVisible: false,
      dialogImageUrl: '',
      formLabelWidth: '120px',
      fileList: [],
      accountingInfo: {
        sumCharge: '',
        sysId: '',
        custId: '',
        sysName: '',
        custName: '',
        startDate: '',
        endDate: ''
      },
      rechargeInfo: {
        custName: '',
        sysId: '',
        custId: '',
        accountName: '',
        sumCharge: '',
        settlementRemark: '',
        dialogImageUrl: '',
        settlCredentialsUrl: []
      },
      checkBatchId: '', // 核算id
      detailInfo: {
        custName: '',
        accountName: '',
        sumCharge: '',
        detailList: [],
        urlList: [],
        remark: ''
      },
      tableData: [],
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    downLoad () { // 下载账单
      let url = this.$API.accounting.downloadBillInfoById
      console.log(this.checkBatchId)
      let params = { // 参数
        checkBatchId: this.checkBatchId,
        mtk: localStorage.getItem('usermtk')
      }
      let form = document.createElement('form')
      form.id = 'form'
      form.name = 'form'
      document.body.appendChild(form)
      for (let obj in params) {
        if (params.hasOwnProperty(obj)) {
          var input = document.createElement('input')
          input.tpye = 'hidden'
          input.name = obj
          input.value = params[obj]
          form.appendChild(input)
        }
      }
      form.method = 'POST' // 请求方式
      form.action = url
      form.submit()
      document.body.removeChild(form)
    },
    rechargeSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.checkBatchId = _this.checkBatchId
          op.totalCharge = _this.rechargeInfo.sumCharge
          op.remark = _this.rechargeInfo.settlementRemark
          op.urlList = []
          for (let v of _this.rechargeInfo.settlCredentialsUrl) {
            op.urlList.push(v)
          }
          let adjustData = [] // 调账数据
          for (let i = 0; i < _this.detailList.length; i++) {
            if (JSON.stringify(_this.detailList[i]) !== JSON.stringify(_this.noAdjust[i])) {
              var obj = {}
              obj.billCheckId = _this.noAdjust[i].billCheckId
              obj.beforeUnitPrice = _this.noAdjust[i].unitPrice
              obj.afterUnitPrice = Number(_this.detailList[i].unitPrice)
              obj.beforeChargeNum = _this.noAdjust[i].chargeNum
              obj.afterChargeNum = Number(_this.detailList[i].chargeNum)
              obj.beforeTotalCharge = _this.noAdjust[i].totalCharge
              obj.afterTotalCharge = Number(_this.detailList[i].totalCharge)
              obj.checkBatchId = _this.noAdjust[i].checkBatchId
              obj.prodName = _this.detailList[i].prodName
              obj.prodId = _this.detailList[i].prodId
              obj.adjustBatch = _this.detailList[i].checkBatch
              obj.remark = _this.rechargeInfo.settlementRemark
              obj.sysId = _this.rechargeInfo.sysId
              obj.custId = _this.rechargeInfo.custId
              adjustData.push(obj) // 增加已经修改的调账数据
            }
          }
          if (adjustData.length > 0) {
            _this.$axios({
              url: _this.$API.accounting.addBillAdjustHistList,
              method: 'post',
              data: { adjustRecords: adjustData }
            }).then((response) => {
              _this.$axios({
                url: _this.$API.accounting.updateCustBillRecord,
                method: 'post',
                data: op
              }).then((response) => {
                _this.query()
                _this.$message.success('调账核账成功！!')
                this.fileList = []
                _this.rechargeDialog = false
              }).catch((err) => {
                console.log(err)
              })
            }).catch((err) => {
              console.log(err)
            })
          } else {
            _this.$axios({
              url: _this.$API.accounting.updateCustBillRecord,
              method: 'post',
              data: op
            }).then((response) => {
              _this.query()
              _this.$message.success('核账成功！!')
              this.fileList = []
              _this.rechargeDialog = false
            }).catch((err) => {
              console.log(err)
            })
          }
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    detail (index, row) {
      let _this = this
      this.checkBatchId = row.checkBatchId
      this.$axios({
        url: _this.$API.accounting.queryBillDetailListById,
        method: 'get',
        params: { checkBatchId: row.checkBatchId }
      }).then((response) => {
        if (response.data.resData) {
          let data = response.data.resData
          _this.detailInfo.custName = data.custName
          _this.detailInfo.accountName = data.accountName
          _this.detailInfo.sumCharge = data.sumCharge
          _this.detailInfo.remark = data.remark
          _this.detailInfo.detailList = data.detailList
          _this.detailInfo.urlList = data.urlList
          this.accountDetailDialog = true
        }
      })
    },
    nuclearAcc (index, row) {
      let _this = this
      this.checkBatchId = row.checkBatchId
      this.dialogImageUrl = ''
      this.$axios({
        url: _this.$API.supplierSettlement.queryBillDetailListById,
        method: 'get',
        params: { checkBatchId: row.checkBatchId }
      }).then((response) => {
        if (response.data.resData) {
          let data = response.data.resData
          _this.rechargeInfo.custName = data.custName
          _this.rechargeInfo.sysId = data.sysId
          _this.rechargeInfo.custId = data.custId
          _this.rechargeInfo.accountName = data.accountName
          _this.rechargeInfo.sumCharge = data.sumCharge
          _this.detailList = data.detailList.concat()
          for (let v of _this.detailList) {
            v.disabled = true // 给输入框禁用
          }
          _this.noAdjust = JSON.parse(JSON.stringify(_this.detailList)) // 复制同样的数据，在核账时比对是否调账
          console.log(_this.rechargeInfo)
          this.rechargeDialog = true
        }
      })
    },
    adjust (index, row) { // 调整
      row.disabled = false
      this.detailList = this.detailList.concat() // 赋值数组 刷新视图
      this.detailList.forEach((v, i) => {
        if (!v.disabled) {
          this.noAdjust[i].disabled = false
        }
      })
    },
    price (val) { // 输入框和js都做过滤
      val.unitPrice = Number(val.unitPrice.toString().match(/^\d+(?:\.\d{0,4})?/))
      val.totalCharge = Number(val.unitPrice * val.chargeNum).toFixed(4)
      val = Object.assign({}, val)
      let total = 0
      for (let v of this.detailList) {
        total = total + Number(v.totalCharge)
      }
      total = total.toFixed(4)
      this.rechargeInfo.sumCharge = total
    },
    call (val) {
      console.log(val)
      val.chargeNum = Number(val.chargeNum.toString().match(/^\d+(?:\.\d{0,4})?/))
      val.totalCharge = Number(val.unitPrice * val.chargeNum).toFixed(4)
      val = Object.assign({}, val)
      let total = 0
      for (let v of this.detailList) {
        total = total + Number(v.totalCharge)
      }
      total = total.toFixed(4)
      this.rechargeInfo.sumCharge = total
    },
    totalCharge (val) {
      val.totalCharge = Number(val.totalCharge.toString().match(/^\d+(?:\.\d{0,4})?/))
      val = Object.assign({}, val)
      let total = 0
      for (let v of this.detailList) {
        total = total + Number(v.totalCharge)
      }
      total = total.toFixed(4)
      this.rechargeInfo.sumCharge = total
    },
    handleRemove (file, fileList) {
      let url = file.response.resData.url
      for (let i = 0; i < this.rechargeInfo.settlCredentialsUrl.length; i++) {
        if (this.rechargeInfo.settlCredentialsUrl[i] === url) {
          this.rechargeInfo.settlCredentialsUrl.splice(i, 1)
        }
      }
      this.dialogImageUrl = ''
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    success (response, file, fileList) {
      if (!response.resCode) {
        this.$router.push('/login')
      }
      if (response.resData.url) {
        this.rechargeInfo.settlCredentialsUrl.push(response.resData.url)
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isJPG.match(/.jpg|.jpeg|png/i)) {
        this.$message.error('上传图片只能是 jpg或jpeg或png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isJPG && isLt2M
    },
    closeRecharge () {
      this.rechargeInfo = {
        sysName: '',
        supName: '',
        sysId: '',
        supId: '',
        supShortName: '',
        accountName: '',
        sumCharge: '',
        settlementRemark: '',
        dialogImageUrl: '',
        settlCredentialsUrl: []
      }
      this.$refs.upload.clearFiles()
      this.rechargeInfo = Object.assign({}, this.rechargeInfo)
      this.rechargeDialog = false
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    createSheet (index, row) { // 生成结算单
      let op = {}
      let _this = this
      op.settlementBatchId = row.checkBatchId
      this.$confirm('确认是否生成结算单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          url: _this.$API.accounting.addBillSettlementRecord,
          data: op
        }).then((response) => {
          _this.query()
          _this.$message.success('新增结算单成功!')
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    reAccount (index, row) { // 重新核算
      let _this = this
      this.checkBatchId = row.checkBatchId
      this.$axios({
        url: _this.$API.accounting.queryCustBillInfoById,
        method: 'get',
        params: { checkBatchId: row.checkBatchId }
      }).then((response) => {
        if (response.data.resData) {
          let data = response.data.resData
          _this.accountingInfo.sysName = data.sysName
          _this.accountingInfo.custName = data.custName
          _this.accountingInfo.sumCharge = data.totalCharge
          _this.accountingInfo.startDate = data.startDate
          _this.accountingInfo.endDate = data.endDate
          _this.accountingInfo.custId = data.custId
          _this.accountingInfo.sysId = data.sysId
          this.accountingDialog = true
        }
      })
    },
    autoAccount () { // 自动核算
      let timeStart = new Date(this.accountingInfo.startDate).getTime()
      let timeEnd = new Date(this.accountingInfo.endDate).getTime()
      let _this = this
      if (timeEnd < timeStart) {
        this.$message.error('截止时间不能小于开始时间')
        return
      }
      let op = {}
      op.startTime = this.accountingInfo.startDate
      op.endTime = this.accountingInfo.endDate
      op.custId = this.accountingInfo.custId
      op.sysId = this.accountingInfo.sysId
      this.$axios({
        url: _this.$API.accounting.autoCustCheckCharge,
        method: 'post',
        data: op
      }).then((response) => {
        if (response.data.resData) {
          _this.accountingInfo.sumCharge = response.data.resData.totalCharge
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.sysId = ''
      this.form.custId = ''
      this.form.state = ''
      this.form.date = ''
    },
    accountingSave () { // 重新核算保存
      let timeStart = new Date(this.accountingInfo.startDate).getTime()
      let timeEnd = new Date(this.accountingInfo.endDate).getTime()
      let _this = this
      if (timeEnd < timeStart) {
        this.$message.error('截止时间不能小于开始时间')
        return
      }
      let op = {}
      op.startTime = this.accountingInfo.startDate
      op.endTime = this.accountingInfo.endDate
      op.custId = this.accountingInfo.custId
      op.sysId = this.accountingInfo.sysId
      op.checkBatchId = this.checkBatchId
      op.totalCharge = this.accountingInfo.sumCharge
      this.$axios({
        url: _this.$API.accounting.addAndDelBillRecord,
        method: 'post',
        data: op
      }).then((response) => {
        _this.query()
        _this.$message.success('重新核算成功')
        _this.accountingDialog = false
      }).catch((err) => {
        console.log(err)
      })
    },
    changeSupName (val) { // 业务系统查询供应商
      let _this = this
      this.$axios({
        url: _this.$API.supplierSettlement.querySupInfoAllBySysId,
        method: 'post',
        data: { sysId: val }
      }).then((response) => {
        if (response.data.resData) {
          _this.supData = response.data.resData
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    initData () {
      this.$store.dispatch('getSystem') // 请求业务系统
      let _this = this
      this.$axios({ // 请求客户名称
        url: _this.$API.rechargeManagement.queryCustSimpleInfoList,
        method: 'post',
        data: {}
      }).then((response) => {
        if (!response.data.resData) return
        _this.form.cusData = response.data.resData
      }).catch((err) => {
        console.log(err)
      })
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.form.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.custId = this.form.custId ? this.form.custId : ''
      op.sysIds = sysIds
      op.checkFlag = this.form.state ? this.form.state : ''
      op.startTime = this.form.date ? this.form.date[0] + ' 00:00:00' : ''
      op.endTime = this.form.date ? this.form.date[1] + ' 23:59:59' : ''
      this.$axios({
        url: _this.$API.accounting.queryBillAsCustListByPage,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/accounting/customerAccounting.vue